module.exports = __webpack_public_path__ + "f5a3e76d5d63d29a49dff0f561b29bab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/question-and-answer.png
// module id = 3040
// module chunks = 0